/**
 * Search-popup A/B test — async runtime layer.
 *
 * The synchronous variant (control = old recent-searches popup, popular_searches = new
 * popular-search popup) is resolved in search-popup-variant-bootstrap.liquid, which sets
 * window.villoidSearchVariant + data-search-popup-variant before the Nosto bundle
 * loads. This file:
 *   - reconciles the bootstrap value against Amplitude Experiment's allocation
 *     (initialVariants + caches the server value for next load — no mid-session flip,
 *     same approach as ab_test_elite_cart.js);
 *   - exposes window.villoidFireSearchExposure(), called (via events.js'
 *     villoidSearchPopupExposed) when the popup is actually shown, so exposure is
 *     only counted for users who saw a variant — symmetric across A and B.
 *
 * Mirrors assets/ab_test_elite_cart.js.
 */
(function () {
  // Amplitude Experiment flag key — the experiment is named "search-enrichment" in the console
  // (the local cache/URL-param naming below still uses "search_popup", which is fine — those are
  // just localStorage/QA keys, independent of the Amplitude flag).
  var FLAG_KEY = 'search-enrichment';
  var DEPLOYMENT_KEY = 'client-2DqaqwX8GjvGBpGSDKXCK0VdOVu1JSp5';
  var CACHE_KEY = 'search_popup_variant';

  var client = null;
  var exposurePending = false;

  function isVariant(v) { return v === 'control' || v === 'popular_searches'; }

  // Amplitude allocates this flag with the house variant keys control/treatment
  // (same as the elite-cart experiment). Our internal id for the treatment is
  // 'popular_searches', so translate. Accept 'popular_searches' too in case the
  // flag is ever keyed directly.
  function mapServerVariant(v) {
    if (v === 'popular_searches' || v === 'treatment') return 'popular_searches';
    if (v === 'control') return 'control';
    return null;
  }

  function readBootstrappedVariant() {
    var v = document.documentElement.getAttribute('data-search-popup-variant');
    return isVariant(v) ? v : null;
  }

  function writeCache(variant) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ variant: variant, ts: Date.now() })); } catch (e) {}
  }

  function waitFor(predicate, callback, maxAttempts, interval) {
    maxAttempts = maxAttempts || 50;
    interval = interval || 100;
    var attempts = 0;
    (function check() {
      if (predicate()) return callback();
      if (++attempts > maxAttempts) return;
      setTimeout(check, interval);
    })();
  }

  // Called from events.js (villoidSearchPopupExposed) when the popup becomes visible.
  // Fires the Experiment exposure for the server-assigned variant. If the client isn't
  // ready yet, remember it and fire once fetch() resolves.
  function fireExposure() {
    if (client) {
      try { client.exposure(FLAG_KEY); } catch (e) {}
    } else {
      exposurePending = true;
    }
  }
  window.villoidFireSearchExposure = fireExposure;

  function reconcile(bootstrap) {
    waitFor(function () { return !!window.Experiment; }, function () {
      try {
        var initialVariants = {};
        initialVariants[FLAG_KEY] = { value: bootstrap };
        client = window.Experiment.initializeWithAmplitudeAnalytics(DEPLOYMENT_KEY, {
          serverZone: 'EU',
          automaticExposureTracking: false,
          initialVariants: initialVariants
        });
      } catch (e) {
        console.warn('[search-popup-ab] Experiment init failed:', e);
        return;
      }

      client.fetch().then(function () {
        var result = client.variant(FLAG_KEY);
        var server = mapServerVariant(result && result.value);
        // Cache the server allocation for the NEXT load — don't flip the live session
        // (the popup may already be rendered for the bootstrap variant).
        if (server && server !== bootstrap) {
          writeCache(server);
        }
        if (exposurePending) {
          exposurePending = false;
          try { client.exposure(FLAG_KEY); } catch (e) {}
        }
      }).catch(function (err) {
        console.warn('[search-popup-ab] experiment.fetch() failed:', err);
      });
    });
  }

  function init() {
    var bootstrap = readBootstrappedVariant();
    if (!bootstrap) return;
    reconcile(bootstrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
